/* SelmaCilek lookbook: Looks / Grid geçişi ve ürün şeridi okları */
(function () {
  function init(root) {
    if (root.dataset.scInit) return;
    root.dataset.scInit = '1';
    var btns = root.querySelectorAll('.sclb-vw [data-v]');
    function setView(v) {
      root.setAttribute('data-view', v);
      btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.v === v)); });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { setView(b.dataset.v); });
    });
    if (btns.length) setView(root.getAttribute('data-view') || 'looks');
    root.querySelectorAll('[data-rail]').forEach(function (b) {
      b.addEventListener('click', function () {
        var r = root.querySelector('.sclb-rail');
        if (r) r.scrollBy({ left: Number(b.dataset.rail) * r.clientWidth * 0.75, behavior: 'smooth' });
      });
    });
  }
  function all() { document.querySelectorAll('.sclb').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
